import { handleActions } from 'redux-actions';
import { setSelectedSegmentId, setNextSegmentId } from './actions';
const initialState = 0;
const selectedSegmentIdReducer = handleActions({
    [setSelectedSegmentId.toString()]: (_, { payload }) => payload,
    [setNextSegmentId.toString()]: state => state + 1
}, initialState);
export default selectedSegmentIdReducer;
